import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpService } from '../../services/HttpService';
import { catchError } from 'rxjs/operators';
import { LocalStorageService } from 'angular-2-local-storage';

@Component({
    selector: 'app-sign-up-form',
    templateUrl: './signup.component.html',
    styleUrls: ['./signup.component.scss']
})

export class SignUpComponent implements OnInit {
    constructor(private router: Router,
        private route: ActivatedRoute,
        private http: HttpService,
        private localStorage: LocalStorageService) { }

    userForm: FormGroup;
    result: string;
    errorMessage: string;
    hasError = false;
    token: string;

    submitForm($event, userForm) {
        userForm.submitted = true;
        this.hasError = false;
        this.errorMessage = '';

        if (userForm.value.password !== userForm.value.confirmPassword) {
            userForm.controls.confirmPassword.setErrors({ match: true });
        }

        if (userForm.value.contactPhone.length < 9) {
            userForm.controls.contactPhone.setErrors({ length: true });
        }

        if (!userForm.valid) {
            return;
        }

        const model = {
            firstName: userForm.value.firstName,
            lastName: userForm.value.lastName,
            email: userForm.value.email,
            skype: userForm.value.skype,
            mobilePhone: userForm.value.contactPhone,
            birthday: userForm.value.birthday,
            password: userForm.value.password,
            persistent: userForm.value.persistent
        };

        this.http.post(`authorization/signup/${this.token}`, model)
            .pipe(catchError(error => this.handleError(error)))
            .subscribe(result => {
                this.localStorage.set('user-roles', result.userRoles);
                this.localStorage.set('user-identity', result.identity);
                this.localStorage.set('token', result.token);
                this.localStorage.set('userName', result.userName);
                this.router.navigate(['/user/profile']);
            });
    }

    handleError(error: any): any {
        this.hasError = true;
        this.errorMessage = error.error;
    }

    ngOnInit(): void {

        this.route.paramMap
            .subscribe((params) => {
                this.token = params.get('token');
                this.userForm = new FormGroup({
                    firstName: new FormControl(),
                    lastName: new FormControl(),
                    email: new FormControl(),
                    skype: new FormControl(),
                    contactPhone: new FormControl(),
                    birthday: new FormControl(),
                    password: new FormControl(),
                    confirmPassword: new FormControl()
                });
            });
    }
}
